/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ManageClaimGroupModel {
        public claimGroups: Wars.Domain.Model.ClaimGroup[];
        public currentClaimGroup: Wars.Domain.Model.ClaimGroup;
        
        constructor(
            private claimGroupService: services.ClaimGroupService,
            private deleteService: services.DeleteService,
            systemLevelService: services.SystemLevelService)
        {
            systemLevelService.getSystemLevelClaimGroups().then(
                (systemLevel) => {
                    this.claimGroups = systemLevel.myClaimGroups;
                });
        }

        public addClaimGroup(): void {
            var newClaimGroup = this.claimGroupService.createNewClaimGroup();
            this.claimGroups.push(newClaimGroup);
            this.currentClaimGroup = newClaimGroup;
        }

        public editClaimGroup(claimGroup: Wars.Domain.Model.ClaimGroup) {
            this.currentClaimGroup = claimGroup;
        }

        public removeClaimGroup(claimGroup: Wars.Domain.Model.ClaimGroup) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ClaimGroup",
                claimGroup.id,
                "Claim Group",
                () => this.claimGroups.remove(claimGroup));
        }

        public save(): void {
            this.claimGroupService.saveAllChanges();
        }

        public close(): void {
            this.currentClaimGroup = undefined;
        }
    }
}